import Const from 'constants';
import Action from 'actions';

let PlayerTeamStacking = {
    setUsageOfPlayersOnlyInTeamStackingFromStorage(checkedPlayers) {
        return {
            type: Const.NON_CONTROLLED_HITTER_STACKING_SET_RESTRICT_PLAYERS,
            checkedPlayers,
        };
    },

    setUsageOfPlayersOnlyInTeamStacking(params, options = {}) {
        return (dispatch, getState) => {
            const {
                nonControlledHitterStacking: {players},
            } = getState();
            const {playerIds, isChecked} = params;
            const {countPlayers = true} = options;

            const checkedPlayers = players.checkedPlayers;

            if (Boolean(isChecked)) {
                playerIds.map((playerId) => (checkedPlayers[playerId] = true));
            } else {
                playerIds.map((playerId) => delete checkedPlayers[playerId]);
            }

            dispatch({
                type: Const.NON_CONTROLLED_HITTER_STACKING_SET_RESTRICT_PLAYERS,
                checkedPlayers,
            });

            countPlayers && dispatch(this.setPlayersCounters());

            dispatch(this.savePlayersOfNonControlledHitterStackingToStorage());
        };
    },

    savePlayersOfNonControlledHitterStackingToStorage() {
        return (dispatch) => {
            dispatch(
                this.saveDataToStorage('nonControlledHitterStackingPlayers', function (state) {
                    const {
                        nonControlledHitterStacking: {players},
                    } = state;
                    return players.checkedPlayers;
                }),
            );
        };
    },
};

export default Object.assign(Action, PlayerTeamStacking);
